export default function Loading({ loadingContent, size }){
    return <div className={"contentloading"}><span class={"loader"} style={{ width: size ?? '1rem', height: size ?? '1rem' }}></span></div>
}